module.exports = __webpack_public_path__ + "static/img/bottom.2100c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom.png
// module id = MGEE
// module chunks = 1